export default "/images/pr-img-5.png?1f9654696905d5a7eaadc730c5eca1a1";